import {
  Alert,
  IconButton,
  Snackbar,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { useGlobalConfig } from "context/GlobalContext";
import { useEffect, useState } from "react";
import styles from "./EVLoadManagement.module.scss";
import EVLoadCard, { EVLoadCardProps } from "./EVLoadCard";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useRequestApiData } from "hooks";
import { EVLoadManagementAPI } from "apis/evLoadManagementAPI";
import { BglLoading } from "components/loading/BglLoading";
import { EVLoadRefreshDialog } from "./evLoadRefreshDialogue/EVLoadRefreshDialog";
import { EV_LOAD_STRINGS } from "types/translations/EVLoadManagementStrings";
import { GetEVLoadAPI } from "types/evLoadManagement/EVLoadManagementInterface";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { EVLOAD_ACTIONS } from "store/actions/evLoadActions";

interface EVLoadManagmentProps {
  scheduleInstantEvent  ?: boolean;
  handleReloadCompleted ?: () => void;
  handleClose           ?: () => void;
}

export const EVLoadManagement = (props : EVLoadManagmentProps) => {
  const { rc } = useGlobalConfig();
  const { translations , config} = rc;
  const theme: Theme = useTheme();

  let [reload, setReload] = useState(0);

  const [refreshDialog, setRefreshDialog] = useState(props.scheduleInstantEvent);

  const isEvLoadRefresh = useSelector((state : any) => state.evLoad.refreshLoad);

  const params: any = {
    pilotId: rc.session.getPilotId(),
  };

  const loadKeys: any = JSON.parse(config.getConfig("EVENT_MANAGEMENT.EV.REALTIME_DASHBOARD_ITEMS")) || []; 

  const { data, error, isLoading } = useRequestApiData<
    GetEVLoadAPI.retval | any
  >(EVLoadManagementAPI.fetchEVLoad, rc, params, [reload]);

  let [trackRefresh, setTrackRefresh] = useState(0);
  const [requestId , setRequestId] = useState<string>();

  const handleRefreshSubmit = async () => {
    const resp: any = await EVLoadManagementAPI.refreshEVLoad(
      rc,
      rc.session.getPilotId()
    );
    if (resp.data) {
      setRequestId(resp.data);
      setTrackRefresh(++trackRefresh);
    }
    setRefreshDialog(false);
  };

  const handleRefreshTrigger = () => {
    if (data?.EV.lastSyncDTO.refreshLeft === 0) {
      toast.error(translations.getTranslation(EV_LOAD_STRINGS.REFRESH_WARNING))
      return;
    }
    setRefreshDialog(true);
  };

  useEffect(() => {
    if (!requestId || !trackRefresh) return;
    (async function fetchData() {
      const resp = await EVLoadManagementAPI.evLoadRefreshStatus(
        rc,
        { requestId: requestId },
        rc.session.getPilotId()
      );
      if (resp.data === "SUCCESS") {
        setTimeout(() => {
          toast.success(translations.getTranslation(EV_LOAD_STRINGS.REFRESH_SUCCESS));
          setReload(++reload);
          setTrackRefresh(0);
        }, 45_000);
        props.handleReloadCompleted && props.handleReloadCompleted();
      } else if (resp.error) {
        toast.error(translations.getTranslation(EV_LOAD_STRINGS.REFRESH_FAILURE));
        setTrackRefresh(0);
        props.handleReloadCompleted && props.handleReloadCompleted();
      } else {
        setTrackRefresh(++trackRefresh);
      }
    })();
  }, [rc, reload, requestId, trackRefresh, translations]);

  useEffect(() => {
    if(props.scheduleInstantEvent){
      setRefreshDialog(true);
    }
  }, [props]);

  const dispatch = useDispatch();
  
  useEffect(() => {
    if(isEvLoadRefresh)
      setReload(++reload);
      dispatch(EVLOAD_ACTIONS.REFRESH_EV_LOAD(false));
  }, [isEvLoadRefresh]);
  
  return (
    <>
      {!props.scheduleInstantEvent && <div className={styles.root}>
        {data?.EV?.lastSyncDTO?.lastSync && <div className={styles.evLoadTitle}>
          <Typography
            variant="bglSubtitle4"
            sx={{ fontWeight: 600 }}
            color={theme.bglPalette.foreground[500]}
          >
            {translations.getTranslation(EV_LOAD_STRINGS.TITLE)}
          </Typography>

          {data?.EV && (!isLoading && !trackRefresh) && (
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="bglBody2"
                sx={{ height: 20 }}
                color={theme.bglPalette.foreground[400]}
              >
                {translations.getTranslation(EV_LOAD_STRINGS.LAST_SYNC)}{" "}
                {data?.EV.lastSyncDTO.lastSync}
              </Typography>
              &nbsp;
              <IconButton
                aria-label="refresh"
                onClick={() => handleRefreshTrigger()}
              >
                <RefreshIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </span>
          )}
        </div>}
        {isLoading || trackRefresh ? (
          <BglLoading className={styles.loadingCont} />
        ) : (
          <div className={styles.evLoadCardsContainer}>
            {data?.EV && loadKeys.map((key: string) => {
              const props: EVLoadCardProps = {
                title: key,
                count: data.EV.countDetails[`${key}Count`],
                kW:  !["enrolled"].includes(key) ? data.EV.loadDetails[`${key}Load`] : undefined,
                tooltipMsg: key,
              };
              return (
                <div key={key}>
                  {" "}
                  <EVLoadCard {...props} />{" "}
                </div>
              );
            })}
          </div>
        )}
      </div>}
      {refreshDialog && (
        <EVLoadRefreshDialog
          open={refreshDialog}
          refreshCount={data?.EV.lastSyncDTO.refreshLeft}
          handleClose={() => { props.handleClose && props.handleClose(); ;setRefreshDialog(false)}}
          handleRefresh={() => handleRefreshSubmit()}
        />
      )}
    </>
  );
};
  